import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=14e9d34e&scoped=true&"
import script from "./news-list.vue?vue&type=script&lang=js&"
export * from "./news-list.vue?vue&type=script&lang=js&"
import style0 from "./news-list.vue?vue&type=style&index=0&id=14e9d34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e9d34e",
  null
  
)

export default component.exports